import(/* webpackMode: "eager", webpackExports: ["PrivacyPolicyContent"] */ "/home/runner/work/breedlogic-frontend-api/breedlogic-frontend-api/breedlogic-web/src/components/TermsAndConditionsDialog/PrivacyPolicyContent.tsx");
